module.exports = __webpack_public_path__ + "static/Andes Rizky-231518b267622fa1115fff517d9e33c4.jpg";